// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-prototyp-page-3',
    // #endregion
    // #region Properties
    props: {
        contextId: {
            type: String,
            required: true,
            default: ''
        },
        itemId: {
            type: String,
            required: false,
            default: ''
        },
        args: {
            type: Object,
            required: false
        },
        mode: {
            type: String,
            required: false,
            default: 'view'
        },
    },
    data: () => ({
        _viewerUrl: '',
        _viewerType: '',
        _viewerData: '',
        _viewerLanguage: 'xml'
    }),
    // #endregion
    // #region Constructor
    beforeMount() {
        this.$host.eventBus.on('viewer-show', this.showInViewer);
    },
    beforeUnmount() {
        this.$host.eventBus.off('viewer-show', this.showInViewer);
    },
    // #endregion
    // #region Core
    methods: {
        async showInViewer(args) {
            if (args.link.viewer === 'pdf') {
                this._viewerType = 'pdf';
                this._viewerUrl = '/assets/lib/pdf/web/viewer.html?file=' + args.link.link + '#zoom=page-width&pagemode=none&search=&phrase=true';
                this._viewerData = '';
            }
            else {
                this._viewerType = 'monaco';
                this._viewerUrl = args.link.link;
                let tData = await (await fetch(this._viewerUrl)).text();
                {
                    if (args.link.viewer === 'text/json') {
                        this._viewerData = JSON.stringify(JSON.parse(tData), null, 2);
                    }
                    else {
                        this._viewerData = tData;
                    }
                }
                if (args.link.viewer === 'text/json') {
                    this._viewerLanguage = 'json';
                }
                else if (args.link.viewer === 'text/xml') {
                    this._viewerLanguage = 'xml';
                }
                else if (args.link.viewer === 'text/sql') {
                    this._viewerLanguage = 'sql';
                }
                else if (args.link.viewer === 'text/yaml') {
                    this._viewerLanguage = 'yaml';
                }
                else {
                    this._viewerLanguage = 'plaintext';
                }
            }
        }
    }
    // #endregion
});
// #endregion
